import { Grid, Label, Modal } from 'semantic-ui-react';
import EditTaskForm from './EditTaskForm';
import React from 'react';
import { H2 } from '../../../../../common/styles/page';
import { primaryColor } from '../../../../../common/constants/globalstyles';
import { FieldItem, FieldLabel, FieldList, FieldValue } from '../../styles/styles';

interface TaskEditModalProps {
  isEditModalVisible: boolean;
  setIsEditModalVisible: (visible: boolean) => void;
  selectedTask: any;
  handleSaveEdit: (task: any) => void;
  updating: boolean;
}

export const TaskEditModal = (props: TaskEditModalProps) => {
  const { isEditModalVisible, setIsEditModalVisible, selectedTask, handleSaveEdit, updating } = props;
  
  // Don't render the modal content if no task is selected
  if (!selectedTask) {
    return null;
  }
  
  return <Modal open={isEditModalVisible} onClose={() => setIsEditModalVisible(false)} size="small">
    <Modal.Header>Edit Task</Modal.Header>
    <Modal.Content>
      <EditTaskForm
        task={selectedTask}
        onSave={handleSaveEdit}
        onCancel={() => setIsEditModalVisible(false)}
        loading={updating}
      />
    </Modal.Content>
  </Modal>
};
